'use client'

import { createContext, useContext, ReactNode } from 'react'

interface ClubRouteContextValue {
  subdomain: string
  urlPrefix: string // Either "/club/demo" or "/demo"
  buildUrl: (path: string) => string
}

const ClubRouteContext = createContext<ClubRouteContextValue | null>(null)

interface ClubRouteProviderProps {
  children: ReactNode
  subdomain: string
  urlPrefix: string
}

export function ClubRouteProvider({ children, subdomain, urlPrefix }: ClubRouteProviderProps) {
  const buildUrl = (path: string) => {
    // Ensure path starts with /
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return `${urlPrefix}${normalizedPath}`
  }

  return (
    <ClubRouteContext.Provider value={{ subdomain, urlPrefix, buildUrl }}>
      {children}
    </ClubRouteContext.Provider>
  )
}

export function useClubRoute() {
  const context = useContext(ClubRouteContext)
  if (!context) {
    throw new Error('useClubRoute must be used within a ClubRouteProvider')
  }
  return context
}
